import {injectable} from "inversify";
import {StaffMember, Negotiator} from "@/modules/staff/entity";
import {AbstractStaffMemberFactory} from "./AbstractStaffMemberFactory";

@injectable()
export class NegotiatorFactory extends AbstractStaffMemberFactory {
  protected make(): StaffMember {
    return new Negotiator();
  }
}
